/**
 * @file Dialog component for confirmation dialog.
 */
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorMessages } from 'apps/driver-dashboardfe/src/app/shared/constants/error-messages.constant';
import { ConfirmationDialog } from '../../models/dialog.model';
import { AuthenticationService } from '../../services/authentication/authentication.service';

/**
 *
 */
@Component({
    standalone: false,
    selector: 'octo-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit {
    disableBtn = false;
    errorMessages = ErrorMessages;
    showLoginBtn = false;

    tempData: any = {
        key: 'value',
    };

    /**
     * Constructor method.
     *
     * @param {MatDialogRef<ConfirmationDialogComponent>} modalRef - Dialog reference.
     * @param {ConfirmationDialog} data - Dialog data.
     * @param {AuthenticationService} authService - Authentication service.
     * @param {ChangeDetectorRef} cd - Change detector reference.
     */
    constructor(
        private modalRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialog,
        private authService: AuthenticationService,
        private cd: ChangeDetectorRef,
        private router: Router
    ) {
        if (this.data.errorStatus === 401 || this.data.errorStatus === 410) {
            this.showLoginBtn = true;
        }
    }

    /**
     * API call to logout.
     *
     */
    logout() {
        this.disableBtn = true;
        this.authService.logOut();
        this.modalRef.close();
    }

    navigateToTaxInfo() {
        this.modalRef.close();
        this.router.navigate(['/my-account/w9details']);
    }

    /**
     * Initialize the component.
     */
    ngOnInit(): void {
        this.cd.detectChanges();
    }

    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.cd.detectChanges();
    }
}
